export default __webpack_public_path__ + "static/hero_support-3dffce7f8d72b0f3e865a8aefdcd2884.jpg";